import React from 'react'

import './Header.css';

const inicio = () =>{
    return true
}


class Header extends React.Component{   
    constructor(props){
        super(props)
        this.state = {
            toggle: false
        }
        this.navBar_info = "Telf. 926210564"
    }
    
    render(){
        return(
            <>
            <div className="navBar_info">
                <a>{this.navBar_info}</a>
            </div>
        </>
        )
    }
}


export default Header
